import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const TAIPEI_TZ = 'Asia/Taipei';

const ZULU = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?Z$/i;
const OFFSET = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?([+-])(\d{2}):?(\d{2})$/;

const fromUtcMs = (ms) => dayjs(ms).tz(TAIPEI_TZ);

/**
 * 諮詢時段一律以台北時間顯示。
 * Carbon JSON 的 `.000000Z` 不能交給 Date 解析，部分瀏覽器會把 UTC 鐘面當成當地時間。
 */
export const taipeiDay = (input) => {
    if (input == null || input === '') return dayjs(null);
    if (dayjs.isDayjs(input)) return input.tz(TAIPEI_TZ);

    const value = String(input).trim();
    const zulu = value.match(ZULU);
    if (zulu) {
        return fromUtcMs(Date.UTC(+zulu[1], +zulu[2] - 1, +zulu[3], +zulu[4], +zulu[5], +(zulu[6] || 0)));
    }

    const offset = value.match(OFFSET);
    if (offset) {
        const sign = offset[7] === '-' ? -1 : 1;
        const offsetMin = sign * (+offset[8] * 60 + +offset[9]);
        const utcMs = Date.UTC(+offset[1], +offset[2] - 1, +offset[3], +offset[4], +offset[5], +(offset[6] || 0))
            - offsetMin * 60 * 1000;
        return fromUtcMs(utcMs);
    }

    return dayjs.tz(value, TAIPEI_TZ);
};

export const taipeiToday = () => fromUtcMs(Date.now()).format('YYYY-MM-DD');
